(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/number-selector/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/lb-ui/number-selector/assets/javascripts/prescript.js');

svs.components = svs.components || {};
svs.components.lbUi = svs.components.lbUi || {};
svs.components.lbUi.numberSelector = svs.components.lbUi.numberSelector || {};
svs.components.lbUi.numberSelector.constants = {
  KEY_E: 69,
  KEY_DOT: 190,
  KEY_MIN: 189,
  KEY_PLUS: 187,
  CLASS_BUTTONS: 'number-selector-button',
  CLASS_INPUT: 'number-selector-input',
  CLASS_ERROR: 'number-selector-error',
  TOGGLE_ERROR_TIMEOUT: 1000 
};


 })(window);